<div class="page-wrapper">
  <main class="main nav-margin d-flex flex-column">
    <div class="container flex-grow-1 h-100 d-flex flex-column">
      <ng-content></ng-content>
    </div>
    <app-global-footer></app-global-footer>
  </main>
  <app-bottom-nav></app-bottom-nav>
</div>
